// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"y3-z"};